/*
 * MOTION DESIGN LTD CONFIDENTIAL
 *
 * [2026] Motion Design Ltd All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Motion Design Ltd. The intellectual and technical concepts contained
 * herein are proprietary to Motion Design Ltd. and may be covered by N.Z.
 * and Foreign Patents, patents in process, and are protected by trade secret
 * or copyright law. Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written permission
 * is obtained from Motion Design Ltd.
 */

export const DEFAULT_SYSTEM_TIME_ZONE = 'Pacific/Auckland'

export function getBrowserTimeZone(): string {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || DEFAULT_SYSTEM_TIME_ZONE
}

export function formatDateTime(value: Date, timeZone: string): string {
    return new Intl.DateTimeFormat('en-NZ', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZone,
        timeZoneName: 'short',
    }).format(new Date(value))
}

export function formatBrowserDateTime(value: Date): string {
    return formatDateTime(value, getBrowserTimeZone())
}
